import { render } from "./text-pane.vue?vue&type=template&id=e5ed2858&scoped=true&ts=true"
import script from "./text-pane.vue?vue&type=script&lang=ts"
export * from "./text-pane.vue?vue&type=script&lang=ts"

import "./text-pane.vue?vue&type=style&index=0&id=e5ed2858&scoped=true&lang=css"

import exportComponent from "E:\\vs2019\\face-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ed2858"]])

export default __exports__